<template>
  <div class="topbar">
    <div class="nav">
      <div class="logo">
        <img :src="logo" alt="">
      </div>
      <div class="" style="flex: 1;display: flex;align-items: center;">
        <ul>
          <li :class="activeIndex == 0 ? 'red' : ''">
            <router-link to="/">首页</router-link>
          </li>
          <li :class="activeIndex == 1 ? 'red' : ''">
            <router-link to="/text">全部直播</router-link>
          </li>
          <li :class="activeIndex == 2 ? 'red' : ''">
            <router-link to="/news">赛程</router-link>
          </li>
        </ul>
        <div class="" style="position: relative;font-weight: normal;font-size: 18px;color: #4b72f6;cursor: pointer;"
          @mouseenter="showTips = true" @mouseleave="showTips = false">
          <div class="" style="font-size: 18px;color: #fff;" @click="goenload">下载app</div>
          <img src="../assets/images/hot.png" alt=""
            style="width: 30px;height: 20px;position: absolute;top: 0;right: -30px;">
          <!-- v-if="showTips"  -->
          <div class="notice-box" v-if="showTips"
            style="background-color: #fff;position: absolute;top: 40px;width: 150px;padding-bottom: 20px;border-radius: 5px;box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.2);">
            <img src="../assets/images/qrcode.png" alt=""
              style="width: 90px;height: 90px;margin: 30px auto 20px;display: block;">
            <div class="" style="text-align: center;font-size: 12px;color: #999;">
              用手机浏览器扫一扫
            </div>
            <div class="" style="text-align: center;font-size: 12px;color: #999;">
              精彩内容马上呈现
            </div>
          </div>
        </div>
      </div>
      <div class="" v-if="info" style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          color: #4b72f6;
          position: relative;
        ">
        <div class="" style="font-size: 18px;position: relative;padding: 20px 0;display: flex;align-items: center;"
          @mouseenter="showyuyue = true" @mouseleave="showyuyue = false" @click="goMine(3)">
          <img src="../assets/images/yuyue.png" alt="" style="width: 20px;height: 20px;margin-right:10px ;">
          <div class="" style="font-size: 18px;">
            预约
          </div>
          <div class="" v-if="showyuyue"
            style="background-color: #fff;position: absolute;top: 60px;width: 250px;border-radius: 5px;box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.2);padding: 10px;right: 0;">
            <div class="" style="display: flex;align-items: center;" v-if="yuyueList.length == 0">
              <img src="../assets/images/none.png" alt="" style="width: 86px;height: 60px;display: block;">
              <div class="" style="text-align: center;font-size: 12px;color: #999;">
                预约列表空空如也~
              </div>
            </div>
            <div class="" v-else>
              <div class="">
                <div class="" v-if="yuyueList.length > 0">
                  <div class="" v-for="(item, index) in yuyueList" :key="index"
                    style="display: flex;align-items: center;margin-bottom: 10px;">
                    <img :src="item.match.league_logo_text" alt="" style="width: 40px;height: 40px;border-radius: 50%;">
                    <div class="" style="margin-left: 10px;">
                      <div class="" style="color: #000;">
                        {{ item.match.match_name }}
                      </div>
                    </div>
                  </div>
                  <div class="" style="background-color: #f1f2f4;text-align: center;margin-top: 10px;">
                    查看更多>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=""
          style="margin: 0 30px;font-size: 18px;position: relative;padding: 20px 0;display: flex;align-items: center;"
          @mouseenter="showguanzhu = true" @mouseleave="showguanzhu = false" @click="goMine(2)">
          <img src="../assets/images/guanhzu.png" alt="" style="width: 20px;height: 20px;margin-right:10px ;">

          <div class="" style="font-size: 18px;">
            关注
          </div>
          <div class="" v-if="showguanzhu"
            style="background-color: #fff;position: absolute;top: 60px;width: 250px;border-radius: 5px;box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.2);padding: 10px;right: 0;">
            <div class="" style="display: flex;align-items: center;" v-if="guanzhuList.length == 0">
              <img src="../assets/images/none.png" alt="" style="width: 86px;height: 60px;display: block;">
              <div class="" style="text-align: center;font-size: 12px;color: #999;">
                关注列表空空如也~
              </div>
            </div>
            <div class="" v-if="guanzhuList.length > 0">
              <div class="" v-for="(item, index) in guanzhuList" :key="index"
                style="display: flex;align-items: center;">
                <img :src="baseUrl+item.avatar" alt="" style="width: 40px;height: 40px;border-radius: 50%;">
                <div class="" style="margin-left: 10px;">
                  <div class="" style="color: #000;">
                    {{ item.nickname }}
                  </div>
                  <div class="" style="color: #999;">
                    一起来聊球
                  </div>
                </div>
              </div>
              <div class="" style="background-color: #f1f2f4;text-align: center;margin-top: 10px;">
                查看更多>
              </div>

            </div>
          </div>
        </div>
        <div class="" @mouseenter="showInfo = true" @mouseleave="showInfo = false" style="position: relative;">
          <img :src="baseUrl+info.avatar" alt="" style="width: 40px; height: 40px; border-radius: 50%; display: block"
            @click="goMine(0)" />
          <!-- <div class="" style="font-size: 16px; margin-left: 10px">
          {{ info.nickname }}
        </div> -->

          <div class=""
            style="position: absolute;top: 40px;right: 0;background-color: #fff;width: 380px; padding: 30px;box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.2);border-radius: 5px;"
            v-if="showInfo">
            <div class="" style="display: flex; align-items: center; color: #333">
              <img :src="baseUrl+info.avatar" alt="" style="
                width: 50px;
                height: 50px;
                border-radius: 50%;
                display: block;
              " />
              <div class="" style="
                flex: 1;
                font-size: 20px;
                font-weight: bold;
                margin-left: 10px;
              ">
                {{ info.nickname }}
              </div>
              <div class="" style="font-size: 14px; border: 1px solid #eee" @click="logout">
                退出登录
              </div>
            </div>
            <div class="" style="height: 12px; width: 100%; margin-top: 20px">
              <el-progress :percentage="percentage" style="width: 100%; height: 12px" :show-text="false">
              </el-progress>
            </div>
            <div class="" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 5px;
            ">
              <div class="" style="
                color: #fff;
                background-color: #bbb;
                padding: 0 10px;
                font-size: 12px;
                border-radius: 5px;
              ">
                Lv.{{ info.level }}
              </div>
              <div class="" style="display: flex">
                <div class="" style="color: #999">经验值</div>
                <div class="" style="color: #000">
                  {{ info.experience }}/{{ info.nextLevel.experience }}
                </div>
              </div>
              <div class="" style="
                color: #fff;
                background-color: #5dd479;
                padding: 0 10px;
                border-radius: 5px;
                font-size: 12px;
              ">
                Lv.{{ info.level + 1 }}
              </div>
            </div>
            <div class="" style="
              width: 100%;
              height: 1px;
              background-color: #eee;
              margin: 30px 0;
            "></div>
            <div class="" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: #000;
            ">
              <div class="" style="text-align: center" @mouseenter="show1 = true" @mouseleave="show1 = false"  @click.stop="goMine(0)">
                <img src="../assets/images/home-active.png" alt="" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  margin: 0 auto 5px;
                " v-if="show1" />
                <img src="../assets/images/home.png" alt="" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  margin: 0 auto 5px;
                " v-else />
                <div class="">个人中心</div>
              </div>

              <div class="" style="text-align: center" @mouseenter="show2 = true" @mouseleave="show2 = false"
                @click.stop="goMine(2)">
                <img src="../assets/images/concern-active.png" alt="" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  margin: 0 auto 5px;
                " v-if="show2" />
                <img src="../assets/images/concern.png" alt="" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  margin: 0 auto 5px;
                " v-else />
                <div class="">我的关注</div>
              </div>

              <div class="" style="text-align: center" @mouseenter="show3 = true" @mouseleave="show3 = false"
                @click.stop="goMine(3)">
                <img src="../assets/images/subscribe-active.png" alt="" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  margin: 0 auto 5px;
                " v-if="show3" />
                <img src="../assets/images/subscribe.png" alt="" style="
                  width: 30px;
                  height: 30px;
                  display: block;
                  margin: 0 auto 5px;
                " v-else />
                <div class="">我的预约</div>
              </div>
            </div>
          </div>
        </div>





      </div>
      <div v-else style="
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          color: #4b72f6;
        ">
        <div class="" style="
            font-size: 18px;
            display: flex;
            align-items: center;
            cursor: pointer;
          " @click="login">
          登录
        </div>
        <div class="" style="
            margin: 0 5px;
            height: 14px;
            width: 1px;
            background-color: #4b72f6;
          "></div>
        <div class=" " style="font-size: 18px; cursor: pointer" @click="register">
          注册
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { getUserInfo, getlogout, getConfig, getConfresguanzhuList, getConfreservationigList } from "../api/user";
import Cookies from "js-cookie";

export default {
  props: ["activeIndex"],
  data() {
    return {
      keywords: "", // 搜索条件
      visible: false, // 是否退出登录
      showTips: false,
      showInfo: false,
      info: {},
      noticeList: [],
      avatar: "",
      show1: false,
      show2: false,
      show3: false,
      logo: "",
      showguanzhu: false,
      showyuyue: false,
      guanzhuList: [],
      yuyueList: [],
      percentage:0
    };
  },
  computed: {
    ...mapGetters(["getUser", "getNum"]),
  },

  mounted() {
    this.info = JSON.parse(localStorage.getItem("user"));

    this.getInfo();
    this.getINfo();
    this.getguanzhuList();
    this.getyuyueList();
  },
  methods: {
    getyuyueList() {
      getConfreservationigList({
        page: 1,
        limit: 3
      }).then((res) => {
        this.yuyueList = res.data.data
      });
    },
    goliveDetail(userId) {
      this.$router.push({
        path: '/details',
        query: {
          userId: userId
        }
      })

    },
    getguanzhuList() {
      getConfresguanzhuList({
        page: 1,
        limit: 3
      }).then((res) => {
        this.guanzhuList = res.data.data
      });
    },
    goDemo() {
      this.$router.push({ path: "/confirmOrder" });
    },
    goMine(type) {
      this.$router.push({ path: "/mine", query: { current: type } });
    },
    logout() {
      this.visible = false;
      localStorage.clear();
      this.avatar = "";
      Cookies.remove("token");
      // 清空vuex登录信息
      this.setUser("");
      this.notifySucceed("成功退出登录");
      this.$forceUpdate();
      this.showInfo = false;
      this.tim.logout();
      this.$router.go(0); // 刷新当前页面
      
      // getlogout().then((res) => {
      //   console.log(res);
      //   this.visible = false;
      //   localStorage.clear();
      //   this.avatar = "";
      //   Cookies.remove("token");
      //   // 清空vuex登录信息
      //   this.setUser("");
      //   this.notifySucceed("成功退出登录");
      //   this.$forceUpdate();
      //   this.showInfo = false;
      //   this.tim.logout();
      //   this.$router.go(0); // 刷新当前页面
      // })

    },
    getINfo() {
      getConfig().then((res) => {
        this.logo = res.data.site_logo;
      });
    },
    getInfo() {
      if (localStorage.getItem("token")) {
        getUserInfo().then((res) => {
          console.log("top的用户信息", res.data);
          if (res.code == 1) {
            this.info = res.data;
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            localStorage.setItem("user", JSON.stringify(res.data));
            this.$store.dispatch("loginTim", "");
            this.percentage=(this.info.experience/this.info.nextLevel.experience)*100
          }
        });
      }
    },
    ...mapActions([
      "setUser",
      "setShowLogin",
      "setShoppingCart",
      "setShowRegister",
    ]),
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
    },
    register() {
      console.log(8468);
      this.setShowRegister(true);
    },
    goenload() {
      this.$router.push({ path: "/addespion" });
    },
  },
};
</script>
<style scoped>
.topbar {
  height: 70px;
  width: 100%;
  color: #fff;
  position: fixed;
  top: 0;
  z-index: 4;
}

.topbar .nav {
  width: 1200px;
  margin: 0 auto;
  height: 70px;
  display: flex;
  align-items: center;
}

.topbar .nav .logo {
  display: flex;
  align-items: center;
  margin-right: 50px;
  color: #fff;
  font-size: 30px;
}

.topbar .nav .logo img {
  width: 160px;
  height: 50px;
  display: block;
}

.topbar .nav ul {
  display: flex;
}

.topbar .nav li {
  height: 70px;
  color: #fff;
  text-align: center;
  line-height: 70px;
  width: 120px;
  font-size: 19px;
}

.topbar .nav li .info {
  display: flex;
  align-items: center;
  height: 40px;
}

.topbar .nav li a {
  color: #fff;
  font-size: 19px;
  width: 120px;
}

.topbar .nav a:hover {
  color: #fff !important;
  background-color: #4b72f6;
  border-radius: 4px;
  padding: 6px 18px;
  font-size: 19px;
}

.topbar .nav li.red a {
  color: #fff !important;
  background-color: #4b72f6;
  border-radius: 4px;
  width: 120px;
  padding: 6px 18px;

  font-size: 19px;
}
</style>
